import { render } from "./HeaderMain.vue?vue&type=template&id=e3b0553a&ts=true"
import script from "./header-main-component.ts?vue&type=script&lang=ts&external"
export * from "./header-main-component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__